module.exports = __webpack_public_path__ + "static/media/secure-transaction.f901e5db.svg";